/** Index after stepping by `delta`, or null when the step would leave the list. */
export const neighborTableIndex = (
  index: number,
  delta: number,
  count: number,
): number | null => {
  if (count <= 0 || index < 0 || index >= count) {
    return null;
  }
  const next = index + delta;
  if (next < 0 || next >= count) {
    return null;
  }
  return next;
};

/** Previous/next and the counter are only useful once a second table exists. */
export const isTableNavVisible = (count: number): boolean => count > 1;

/**
 * Insert `id` before the first existing id for which `isBefore` is true.
 * Returns the same array when `id` is already present.
 */
export const insertTableId = (
  ids: readonly string[],
  id: string,
  isBefore: (id: string, existingId: string) => boolean,
): readonly string[] => {
  if (ids.includes(id)) {
    return ids;
  }
  const index = ids.findIndex(existing => isBefore(id, existing));
  if (index === -1) {
    return [...ids, id];
  }
  return [...ids.slice(0, index), id, ...ids.slice(index)];
};

/** Drop `id`. Returns the same array when it was not present. */
export const removeTableId = (
  ids: readonly string[],
  id: string,
): readonly string[] => {
  if (!ids.includes(id)) {
    return ids;
  }
  return ids.filter(existing => existing !== id);
};
